import {CreateAccessor} from "mobx-graphlink";

/*export function GetTermsInDreamSegmentText(text: string, dedup = false) {
	let result = text
		.toLowerCase()
		.replace(/\s+/g, " ") // collapse each chain of whitespace (including "\r" and "\n") to just a single space
		.split(" ")
		.map(str=>{
			let charsToKeep = `a-zA-Z0-9\\-_@=`;
			// allow brackets in term-name only if both sides of the bracket are included
			if (str.includes("(") && str.includes(")")) charsToKeep += "()";
			if (str.includes("[") && str.includes("]")) charsToKeep += "[]";
			return str.replace(new RegExp(`[^${charsToKeep}]`, "g"), "");
		})
		.filter(a=>a.length > 0);
	if (dedup) result = result.Distinct();
	return result;
}*/

// ----- char-sets -----
export const chars_word_core = "a-zA-Z0-9";
// "Extender" chars result in parsing of two words: [chars before extender], and [chars before extender + extender + chars after extender]
// Example: For the string "friend's", we read that as two separate words: "friend" and "friend's"
export const chars_word_extenders = "'\\-_";
// ----- regexes -----
export const regex_word_core = new RegExp(`[${chars_word_core}]+`, "g");
//export const regex_word_corePlusExtenders = new RegExp(`[${chars_word_core}${chars_word_extenders}]+`, "g");
export const regex_word_corePlusExtenders = new RegExp(`[${chars_word_core}${chars_word_extenders}]*[${chars_word_core}][${chars_word_core}${chars_word_extenders}]*`, "g"); // 3-part, to exclude "--" and such as independent words
//export const regex_word_core_notTouchingExtenders = new RegExp(`(?<![${chars_word_core}${chars_word_extenders}])[${chars_word_core}]+(?![${chars_word_core}${chars_word_extenders}])`, "g");

/** Note: A "word shard" would be the "friend" in the larger word "friend's", or the "pre" in the larger word "pre-authorization". */
export const GetWordsInText_Array = CreateAccessor((text_raw: string, includeWordShards: boolean, lowercase = true, excludeTimestamps = false)=>{
	let text = text_raw;
	if (lowercase) text = text.toLowerCase();
	if (excludeTimestamps) {
		// remove timestamps of format "[hh:mm:ss]" or "[hh:mm]"
		text = text.replace(/\[\d{1,2}:\d{2}(?::\d{2})?\]/g, " ");
	}

	const result = new Array<string>();

	let match: RegExpExecArray|null;
	while ((match = regex_word_corePlusExtenders.exec(text)) != null) {
		let largeWord = match[0];

		// IF we're not including word-shards...
		if (!includeWordShards) {
			// ...then we want to be sure we don't interpret "Then she said 'these wrong'" as not containing the word "these" or "wrong"...
			// ...so, strip any extenders from the start and end of the word
			// (note that this can narrow the "Holmes'" in "Holmes' hat" to just "Holmes", but that's an acceptable trade-off)
			while (largeWord.StartsWithAny("'", "-", "_")) largeWord = largeWord.slice(1);
			while (largeWord.EndsWithAny("'", "-", "_")) largeWord = largeWord.slice(0, -1);
		}

		result.push(largeWord);

		// if we're including word-shards in our result, we have to see what shards (if any) this large-word contains
		if (includeWordShards) {
			const wordShardMatches = [...largeWord.matchAll(regex_word_core)];
			for (const wordShardMatch of wordShardMatches) {
				const wordShard = wordShardMatch[0];
				if (wordShard == largeWord) continue; // skip re-adding the large-word itself (in case there's no sharding)
				result.push(wordShard);
			}
		}
	}

	return result;
});
export const GetWordsInText_Map = CreateAccessor((text_raw: string, includeWordShards: boolean, lowercase = true)=>{
	return new Set(GetWordsInText_Array(text_raw, includeWordShards, lowercase));
});
export const GetWordsInText_Array_Deduped = CreateAccessor((text_raw: string, includeWordShards: boolean, lowercase = true)=>{
	return Array.from(GetWordsInText_Map(text_raw, includeWordShards, lowercase));
});
/*export const GetWordsInText_Map = CreateAccessor((text_raw: string, lowercase = true)=>{
	const text = lowercase ? text_raw.toLowerCase() : text_raw;
	const regex_core = new RegExp(`[${wordChars_core}]+`, "g");
	const regex_corePlusExtenders = new RegExp(`[${wordChars_core}${wordChars_extenders}]+`, "g");
	const result = new Set<string>();
	let match;
	while ((match = regex_core.exec(text)) !== null) {
		result.add(match[0]);
	}
	while ((match = regex_corePlusExtenders.exec(text)) !== null) {
		result.add(match[0]);
	}
	return result;
});*/